import React, { useState, useEffect, Fragment, useRef } from 'react'
import {
  Select, Form, Input, Button, Modal,
  Upload, Row, Col, DatePicker, message, InputNumber, Space, Radio, TreeSelect, Tree,TimePicker,Divider
} from "antd";
import { LoadingOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import HandleButton from "@/components/HandleButton"
import RoleApi from '@api/role'

import ResourceApi from '@api/resource'
// import Title from '@/components/Title'
// import MinTitle from '@/components/MinTitle'
// import MessageApi from '@api/message'
import AddModal from '@components/Modal'
// import moment from 'moment';
// const { UPLOADER } = window.globalConfig;
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import InspectionApi from '@api/inspectionnew'
import { identifierData, cycleData } from '@utils/common'
import moment from 'moment';
import '../style.scss'
const { RangePicker } = DatePicker
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option
let childIds = ''

const PlanAdd = ({ title, visible, formData = null, cancel, stationData }) => {
  const [form] = Form.useForm();
  const [editBool, setEditBool] = useState(false)
  const [formValue, setFormValue] = useState()
  const [loading, setLoading] = useState()
  // 所有的树形id
  // 巡检模版
  const [tempentItems, setTempentItems] = useState([])
  // 巡检人员数组
  const [personItems, setPersonItems] = useState([])
  // 人员选择
  const [personType, setPersonType] = useState()
  const [standardList,setStandardList] = useState([])
  const [days,setDays] =  useState([]);
  const [timeNum, setTimeNum] = useState([])
  const [periodArr,setPeriodArr] = useState([])
  // 厂站集合
  useEffect(() => {   
    form.setFieldsValue(formData)
    if (formData && formData.id) {
      getInfo(formData.id)
    } else{
      setFormValue(formData);
    }
    InspectionApi.standQuery({  pageNum: 1,pageSize: 100}).then(res => {
      setStandardList(res.data.data)
    })
    let dayArry = [];
    for(let i = 1; i< 29;i++){
      dayArry.push(i)
    }
    setDays(dayArry);
    RoleApi.getDictByType('patrol_plan_period_type').then(rest =>{ //写标准类型
      
      setPeriodArr(rest.data)

    })
    return () => { }
  }, [visible])
  const getInfo = (id) => {
    InspectionApi.planInfo(id).then(res => {
      if (res.status == 0) {
        let newData = res.data;
        let patrolPlanPeriodAddDTOS = []
        newData.patrolPlanPeriodPOS.map(item => {
          let {period,weekDay,month,day} = item
          let time = [moment(item.beginTime,'HH:mm'), moment(item.endTime,'HH:mm')]
          let dateday =   moment(item.date)
          patrolPlanPeriodAddDTOS.push({period:''+period,weekDay,month,time,day,dateday})
          // return item;
        })
        newData.patrolPlanPeriodAddDTOS = patrolPlanPeriodAddDTOS;
        console.info(newData)
        setFormValue(newData)
        form.setFieldsValue(newData)
       
        // getDatas()
        // setTimeNum(JSON.parse(res.data.taskTimeTemplate).map(v => {
        //   return [moment(v.beginTime), moment(v.endTime)]
        // }))
      }
    })
  }
  const submit = () => {
    
    form.validateFields().then(values => {
      if(!values){
        return;
      }
      setLoading(true)
      let param = {...values}
      param.patrolPlanPeriodAddDTOS.map(item => {
        item.beginTime =  moment(item.time[0]).format('HH:mm:ss')
        item.endTime =  moment(item.time[1]).format('HH:mm:ss')
        item.date =  moment(item.dateday).format('YYYY-MM-DD')
        return item;
      })
      console.info(param)
      // let param = {
      //   planName: values.planName,
      //   type: values.type,
      //   stationId: typeof values.stationId === 'string' ? values.stationId : values.stationId.join(','),
      //   templateId: values.templateId.join(','),
      //   beginTime: moment(values.beginTime).format('YYYY-MM-DD'),
      //   // 巡检人iD
      //   patrolUserId: user[0], // users.map(v => v.id).join(','),
      //   // 巡检人 名称
      //   patrolUserName: user[1] // users.map(v => v.realName).join(','),
      // }
      if (formData && formData.id) {
        param.id = formData.id
      }
      if (formData && formData.id) {
        InspectionApi.planEdit(param).then(res => {
          if (res.status == 0) {
            message.success('编辑成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      } else {
        InspectionApi.planAdd(param).then(res => {
          if (res.status == 0) {
            message.success('新建成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
    })
  }
  // 取消操作
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }
  // 巡检类型-获取人员列表
  const handleType = (val) => {
    console.log(val, 'handleChange')
    setPersonType(val)
    form.setFieldsValue({ stationId: null })
    getDatas()
  }
  // 巡检场站
  const changeStation = (val) => {
    getDatas()
    // setStationIds(val)
  }
  // 获取模版列表, 获取人员列表
  const getDatas = () => {
    const stationIds = form.getFieldValue('stationId')
    const type = form.getFieldValue('type')
    if (stationIds && type !== null) {
      // 获取模版列表
      InspectionApi.query({pageNum:1,pageSize:100}).then(res => {
        if (res.status == 0 && res.data.data) {
          setTempentItems(res.data.data || [])
        }
      })
      const ids = (stationIds instanceof Array) ? stationIds.join(',') : stationIds
      // 获取人员列表
      RoleApi.queryRoleUserByIdentifier({ stationIds: ids, identifier: identifierData[type] }).then(res => {
        if (res.status == 0 && res.data) {
          setPersonItems(res.data || [])
        }
      })
    }
  }
  // 周期类型
  const periodChange = (e,index) => { 
    const newformVale = {...form.getFieldValue()}
    console.info(e,newformVale,form.getFieldValue());

    newformVale.patrolPlanPeriodAddDTOS[index].period = e;
    setFormValue(newformVale)
  }
  const slectProps = personType == 1 ? { mode: 'multiple' } : {}
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={800} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form preserve={false}
          {...layout}
          name="basic"
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
          initialValues={formValue}
        >
          {/* <Row> */}
          <Col span={18}>
            <Form.Item
              label='巡检计划名称:'
              name="planName"
              prop='planName'
              rules={[{ required: true, message: '请输入巡检计划名称!' }]}
            >
              <Input disabled={editBool} placeholder={'请输入巡检计划名称'} />
            </Form.Item>
          </Col>
          {/* stationData */}
          <Col span={18}>
            <Form.Item
              label='巡检标准'
              name="standardId"
              rules={[{ required: true, message: '请选择巡检巡检标准!' }]}
            >
              <Select allowClear placeholder="请选择" onChange={handleType}>
                {standardList.map(item =>{
                  return <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
          <Form.Item layout="horizontal"
              label='巡检计划周期'
              name=""              
            >
            <Form.List name="patrolPlanPeriodAddDTOS" prop='patrolPlanPeriodAddDTOS'>
            {(fields, { add, remove }) => (
            <>
              {fields.map((field,index) => (
                <Row key={field.key}>
                <Col span={22}>
                <Space  style={{ width: '100%' ,display: 'block'}}>
                  <Form.Item
                      label='周期'
                      name={[field.name, 'period']}
                      rules={[{ required: true, message: '请选择缺周期' }]}
                    >
                    <Select allowClear placeholder="请选择" onChange={(e) => periodChange(e,index)}>
                      {periodArr.map(item => {
                        return <Select.Option value={item.dictKey} key={`type${item.dictKey}`}>{item.dictValue}</Select.Option>
                      })}
                    </Select>
                  </Form.Item>                  
                  {formValue.patrolPlanPeriodAddDTOS && formValue.patrolPlanPeriodAddDTOS[index] && formValue.patrolPlanPeriodAddDTOS[index].period == 4 &&
                    <Form.Item
                    label='巡检日期'  
                    name={[field.name, 'dateday']}
                    rules={[{ required: true, message: '请选择巡检日期!' }]}
                  >
                     <DatePicker /> 
                  </Form.Item>  
                  } 
                  {formValue.patrolPlanPeriodAddDTOS && formValue.patrolPlanPeriodAddDTOS[index] && formValue.patrolPlanPeriodAddDTOS[index].period == 1 &&
                    <Form.Item
                    label='巡检日'  
                    name={[field.name, 'weekDay']}
                    rules={[{ required: true, message: '请选择巡检日!' }]}
                  >
                    <Select allowClear placeholder="请选择">
                      <Select.Option value={1}>星期一</Select.Option>
                      <Select.Option value={2}>星期二</Select.Option>
                      <Select.Option value={3}>星期三</Select.Option>
                      <Select.Option value={4}>星期四</Select.Option>
                      <Select.Option value={5}>星期五</Select.Option>
                      <Select.Option value={6}>星期六</Select.Option>
                      <Select.Option value={7}>星期天</Select.Option>
                    </Select>
                  </Form.Item>  
                  } 
                  {formValue.patrolPlanPeriodAddDTOS && formValue.patrolPlanPeriodAddDTOS[index] && formValue.patrolPlanPeriodAddDTOS[index].period == 3 &&
                    <Form.Item
                    label='第几月'  
                    name={[field.name, 'month']}
                    rules={[{ required: true, message: '请选择第几月!' }]}
                  >
                    <Select allowClear placeholder="请选择">
                      <Select.Option value={1}>1</Select.Option>
                      <Select.Option value={2}>2</Select.Option>
                      <Select.Option value={3}>3</Select.Option>
                    </Select>
                  </Form.Item>  
                  } 
                  {formValue.patrolPlanPeriodAddDTOS && formValue.patrolPlanPeriodAddDTOS[index] && ['2','3'].indexOf(formValue.patrolPlanPeriodAddDTOS[index].period) > -1 &&
                    <Form.Item
                    label='第几天'  
                    name={[field.name, 'day']}
                    rules={[{ required: true, message: '请选择第几天!' }]}
                  >
                    <Select allowClear placeholder="请选择">
                      {
                        days.map(item => {
                         return <Select.Option key={`day-${item}`} value={item}>{item}</Select.Option>
                        })
                      }
                    </Select>
                  </Form.Item>  
                  } 
                  
                  
                  {formValue.patrolPlanPeriodAddDTOS && formValue.patrolPlanPeriodAddDTOS[index] && formValue.patrolPlanPeriodAddDTOS[index].period == 0 && <Form.Item
                    label='时间段'
                    name={[field.name, 'time']}
                    rules={[{ required: true, message: '请选择缺时间段' }]}
                  >
                    <TimePicker.RangePicker format='HH:mm:ss'/>
                  </Form.Item>
                  }
                </Space>
                </Col>
                <Col span={2}>
                {fields.length > 1 && <MinusCircleOutlined onClick={() => {
                  let newVa = {...form.getFieldValue()}
                  newVa.patrolPlanPeriodAddDTOS.splice(index,1)
                  setFormValue(newVa)
                  form.setFieldsValue(newVa)
                }} style={{marginLeft:'15px',marginTop:'60px'}}/>}
                </Col>
                {fields.length > 1 &&<Divider  dashed style={{marginTop:'0px'}}></Divider>}
                </Row>
              ))}

              <Form.Item>
                <Button type="dashed" onClick={() => add({period:'',weekDay:'',month:'',time:[],day:'',date:0})} >
                  添加
                </Button>
              </Form.Item>
            </>
          )}
            </Form.List>
          </Form.Item>
          </Col>
         
        </Form >
      </div >
    </AddModal >
  )

}

export default PlanAdd
